<rask-page pageTitle="{{ avtalState + ' avtal'}}">
    @if (avtal) {
    <rask-container-block [noBorder]="true">
        <rask-header size="2" underline>
            <div class="d-flex">
                <span>Allmän information</span>
            </div>
        </rask-header>
        <rask-virkeskop-validation-message entityType="avtal"></rask-virkeskop-validation-message>
        <rask-input class="col-4"
            label="Benämning"
            [(ngModel)]="avtal.benamning"
            (change)="avtalEdited()"
            [maxlength]="avtalBenamningMaxLength"
            [disabled]="!canEdit()">
        </rask-input>
        @if(isSkogsvardFPV){
        <rask-search
            raskVirkeskopRule [messageId]="['ansvarigSaljare']"
            aid="inputAnsvarigSaljare"
            class="col-4"
            label="Kundansvarig försäljning"
            [required]="false"
            bindLabel="name"
            bindValue="id"
            typeToSearchText="{{ 'LEVERANTOR_DETAIL_TYPE_AHEAD_HELP_TEXT' | translate }}"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="searchForAnsvarigVirkeskopareTypeAhead"
            [selected]="avtal.ansvarigSaljare"
            [compareWith]="ansvarigAnvandareCompareWith"
            (selectedChanged)="ansvarigSaljareChanged($event)">
        </rask-search>
        }@else {
        <rask-simple-selector
            class="col-2"
            label="Anskaffningsform"
            [(ngModel)]="avtal.anskaffningsform"
            (change)="avtalEdited()"
            [values]="anskaffingsformer"
            [disabled]="!canEdit()">
        </rask-simple-selector>
        }
        <rask-textmultiline class="col-3" label="Avtalsnummer" [value]="avtal.avtalsnummer"></rask-textmultiline>

        <ng-container
            *raskPermitted="[{ role: 'RASK.Kopleda', canEdit: true }]; hide: false; let edit = canEdit">
            @if(edit || isSkogsvardFPV) {
            <rask-search
                raskVirkeskopRule [messageId]="['ansvarigvirkeskopare']"
                aid="inputAnsvarigVirkeskopare"
                class="col-4"
                [label]="ansvarigTitle"
                [required]="true"
                bindLabel="name"
                bindValue="id"
                typeToSearchText="{{ 'LEVERANTOR_DETAIL_TYPE_AHEAD_HELP_TEXT' | translate }}"
                loadingText="Laddar..."
                notFoundText="Ingen träff"
                [minTermLength]="3"
                [typeaheadFn]="searchForAnsvarigVirkeskopareTypeAhead"
                [compareWith]="ansvarigAnvandareCompareWith"
                [selected]="avtal.ansvarigVirkeskopare"
                (selectedChanged)="ansvarigVirkeskopareChanged($event)">
            </rask-search>
            }
            @else{
            <rask-input class="col-4" disabled
                [label]="ansvarigTitle"
                [value]="avtal.ansvarigVirkeskopare.name">
            </rask-input>
            }
        </ng-container>

        @if(isNew && !isSkogsvardFPV) {
        <rask-radiobutton-group
            class="col-4"
            label="Första kontraktet på avtalet avser"
            aid="forstaKontraktetpaAvtaletAvser"
            [buttons]="[{ key: false, value: 'Rundvirke, Grot'  }, { key: true, value: 'Skogsvårdskontrakt' }]"
            [(ngModel)]="avtal.isFirstDefaultKontraktSkogsvard"
            (change)="avtalEdited()">
        </rask-radiobutton-group>
        }
    </rask-container-block>
    }

    <rask-leverantorer></rask-leverantorer>

    @if (hasLeverantor && !isNew) {
    <rask-kontrakt-list [isSkogsvardFPV]="isSkogsvardFPV"></rask-kontrakt-list>
    }
    <ng-container footerLeft>
        <div class="savebutton d-flex">
            @if (!isSkogsvardFPV) {
            <rask-kontrakt-vacs
                *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true">
            </rask-kontrakt-vacs>
            }

            <div
                class="d-flex"
                (mouseleave)="iconPopover.closePopover()"
                (mouseenter)="iconPopover.openPopover()">
                <rask-save-button
                    class="m-0"

                    (click)="save()"
                    [disabled]="!canSave()"
                    icon="fa-save far icon">
                    <span>Spara</span>
                    @if (isWorking) {
                    <rask-busy-spinner class="ms-1" size="1"></rask-busy-spinner>
                    }
                </rask-save-button>
                @if (!hasLeverantor) {
                <rask-icon ngClass="test" icon="fas fa-info-circle" text="Sök och lägg till en leverantör, eller skapa en ny leverantör för att
                    påbörja
                    ett kontrakt."></rask-icon>
                }
                <rask-virkeskop-validation-icon-popover
                    #iconPopover
                    iconStyle="fa-solid"
                    [context]="errorContext">
                </rask-virkeskop-validation-icon-popover>
            </div>


        </div>
    </ng-container>
</rask-page>